import {
    CollectionReference,
    DocumentData,
    DocumentReference,
  } from "@um/contracts/firestore";
import { WithRef } from "./schema";

let firestoreSchemaProvider: FirestoreContractProvider = {
    getCollection: (path: string, parent?: DocumentReference) => {
      throw new Error("setContractProvider must be called first");
    },
    getDocument: <T = DocumentData>(path: string, parent?: CollectionReference<T>) => {
      throw new Error("setContractProvider must be called first");
    },
    getWithRef: async <T = DocumentData>(ref: DocumentReference<T> | string | WithRef<T>) => {
      throw new Error("setContractProvider must be called first");
    },
    getEnv: (key: string) => {
      throw new Error("setContractProvider must be called first");
    },
    isEmulator: () => {
      throw new Error("setContractProvider must be called first");
    },
    isProduction: () => {
      throw new Error("setContractProvider must be called first");
    },
  };
  
  export interface FirestoreContractProvider {
    getCollection<T = DocumentData>(path: string, parent?: DocumentReference): CollectionReference<T>;
    getDocument<T = DocumentData>(path: string, parent?: CollectionReference<T>): DocumentReference<T>;
    getWithRef<T = DocumentData>(ref: DocumentReference<T> | string | WithRef<T>): Promise<WithRef<T>>;
    getEnv(key: string): string | undefined;
    isEmulator(): boolean;
    isProduction(): boolean;
  }
  
  export function setFirestoreContractProvider(provider: FirestoreContractProvider) {
    firestoreSchemaProvider = provider;
  }

  export function getFirestoreContractProvider(): FirestoreContractProvider {
    return firestoreSchemaProvider;
  }

  